var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContextmenuLock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3991_12916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83334 9.16675H14.1667C15.0872 9.16675 15.8333 9.91294 15.8333 10.8334V15.8334C15.8333 16.7539 15.0872 17.5001 14.1667 17.5001H5.83334C4.91287 17.5001 4.16668 16.7539 4.16668 15.8334V10.8334C4.16668 9.91294 4.91287 9.16675 5.83334 9.16675Z",
    stroke: "#2B2B35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 14.1667C9.53977 14.1667 9.16668 13.7936 9.16668 13.3333C9.16668 12.8731 9.53977 12.5 10 12.5C10.4602 12.5 10.8333 12.8731 10.8333 13.3333C10.8333 13.7936 10.4602 14.1667 10 14.1667Z",
    fill: "#2B2B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 9.16675V5.00008C13.3333 4.11603 12.9822 3.26818 12.357 2.64306C11.7319 2.01794 10.8841 1.66675 10 1.66675C9.11595 1.66675 8.26811 2.01794 7.64299 2.64306C7.01787 3.26818 6.66668 4.11603 6.66668 5.00008",
    stroke: "#2B2B35",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3991_12916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "matrix(-1 0 0 1 20 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContextmenuLock);
export default __webpack_public_path__ + "static/media/contextmenu_lock.d2ddd3bf563f713030441a989d05952f.svg";
export { ForwardRef as ReactComponent };